export default "__VITE_ASSET__74dda9e6__"